import * as React from 'react';

import { SearchInput } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface Props {
	filterText: string;
	onFilterTextChange: (filterText: string) => void;
	openBulkFilter?: () => void;
}

const FilterInput: React.FC<Props> = (props) => {
	const { onFilterTextChange, filterText, openBulkFilter } = props;

	// The bulk layout moves the search icon ahead of the text so the trailing
	// slot is free for the bulk filter button
	const isBulk = !!openBulkFilter;

	return (
		<div className={styles.searchInput}>
			<SearchInput
				additionalAction={isBulk ? openBulkFilter : undefined}
				additionalActionIcon={isBulk ? 'FilterAdvanced' : undefined}
				name="filterText"
				onChange={onFilterTextChange}
				placeholder="Search"
				value={filterText}
			/>
		</div>
	);
};

export default React.memo(FilterInput);
